<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-toolbar-title>Empresa {{ empresa.nome }}</v-toolbar-title>

        <v-spacer />
      </v-toolbar>

      <DataTableDeCrud
        :items="filiais"
        :headers="headers"
        titulo="Filial"
        :permissao-geral="true"
        :configurar="false"
        :loading="loading"
        @create="() => abrirDialogAdicionarFilial()"
        @update="(indice) => abrirDialogEditarFilial(indice)"
        @delete="(indice) => abrirDialogExcluirFilial(indice)"
      >
        <template #[`item.status`]="{ item }">
          <v-icon v-if="item.status" color="green">mdi-check</v-icon>
          <v-icon v-else color="red">mdi-close</v-icon>
        </template>
      </DataTableDeCrud>
    </v-card>

    <DialogDeEdicaoDeFilial
      :show-dialog-vinculo.sync="showDialogParam"
      :filial-param="filialParam"
      :itens-filial="itensFilial"
      :operacao="operacao"
      :empresa="empresa"
      @confirmado="atualizarFilial"
    />

    <SnackbarMessage
      :show-snack.sync="snackbar.showSnackParam"
      :snack-text="snackbar.snackTextParam"
      :snack-type="snackbar.snackTypeParam"
    />

    <v-dialog v-model="dialogExcluirFilial" persistent max-width="380">
      <v-card>
        <v-card-title class="headline">Excluir</v-card-title>
        <v-card-text refs="itemPermissaoExclusao">
          Tem certeza que deseja remover a filial
          <b> {{ itemFilialExclusao.nome }} </b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogExcluirFilial = false">Cancelar</v-btn>
          <v-btn color="green darken-1" text @click="excluirFilial">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import FilialService from '@/services/empresa/filial'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeEdicaoDeFilial from './DialogDeEdicaoDeFilial'
import SnackBar from '@/models/components/snackbar'
import Empresa from '@/models/empresa'
import Filial from '@/models/filial'
import { formataCpfCnpj } from '@/shareds/formatacoes'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeFilial
  },
  props: ['showDialogSettings', 'empresa'],
  data: () => ({
    headers: [
      { text: 'Nome', value: 'nome' },
      { text: 'Documento', value: 'documento' },
      { text: 'Status', value: 'status' }
    ],
    filiais: [],
    loading: false,
    validForm: false,
    dialog: false,
    dialogAdicionarFilial: false,
    showDialogParam: false,
    filialParam: new Filial(),
    itensFilial: {},
    operacao: 'adicionar',
    snackbar: new SnackBar(),
    dialogExcluirFilial: false,
    itemFilialExclusao: new Empresa(),
    indiceFilialExclusao: 0
  }),

  watch: {
    showDialogSettings() {
      return this.showDialogSettings ? (this.dialog = this.showDialogSettings) : ''
    },
    empresa() {
      return this.empresa ? this.initialize(this.empresa) : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },

  methods: {
    initialize() {
      this.buscarFiliaisDaEmpresa(this.empresa.id)
    },

    async buscarFiliaisDaEmpresa(empresaId) {
      try {
        const response = await FilialService.getByEmpresa(empresaId)
        this.filiais = response.map((item) => ({
          ...item,
          documento: formataCpfCnpj(item.documento)
        }))
      } catch (error) {
        this.snackbar.snackTextParam =
          'Não foi possível encontrar filiais cadastradas para esta empresa.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    atualizarFilial(filial) {
      if (!filial) return

      const indice = this.filiais.findIndex((filialExistente) => filialExistente.id === filial.id)

      filial.documento = formataCpfCnpj(filial.documento)

      this.operacao === 'adicionar'
        ? this.filiais.push(filial)
        : this.filiais.splice(indice, 1, filial)
      this.snackbar.snackTextParam = 'Filial cadastrada com sucesso.'
      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    abrirDialogExcluirFilial(indice) {
      this.itemFilialExclusao = this.filiais[indice]
      if (!this.itemFilialExclusao.id) return

      this.indiceFilialExclusao = indice
      this.dialogExcluirFilial = true
    },

    async excluirFilial() {
      try {
        await FilialService.deleteById(this.itemFilialExclusao.id)
        this.snackbar.snackTextParam = 'Filial removida com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.filiais.splice(this.indiceFilialExclusao, 1)
      } catch (error) {
        this.snackbar.snackTextParam = `${error.response.status} | ${
          error.response.data.message === undefined ? error.message : error.response.data.message
        }`
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogExcluirFilial = false
    },

    abrirDialogAdicionarFilial() {
      this.operacao = 'adicionar'
      this.filialParam = new Filial()
      this.showDialogParam = true
    },

    abrirDialogEditarFilial(indice) {
      this.filialParam = { ...this.filiais[indice] }
      this.operacao = 'editar'
      this.showDialogParam = true
    },

    fecharDialog() {
      this.$emit('update:showDialogSettings', false)
    }
  }
}
</script>
